module.exports = __webpack_public_path__ + "img/MapThumb_Grasslands.f2e6972d.webp";